import { render, staticRenderFns } from "./AddCoupon.vue?vue&type=template&id=1670f050&scoped=true&"
import script from "./AddCoupon.vue?vue&type=script&lang=js&"
export * from "./AddCoupon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1670f050",
  null
  
)

export default component.exports